import RootPage from './custom-pages.page'
import CustomPageDetails from './custom-page-details.page'


let routes = [
  {
    path: 'custom-pages',
    name: 'custom-pages',
    component: RootPage
  },
  {
    path: 'custom-page-:pageId',
    name: 'custom-page-details',
    component: CustomPageDetails
  },
]

export default routes
